"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _isNil = _interopRequireDefault(require("lodash/fp/isNil"));
var _isFunction = _interopRequireDefault(require("lodash/fp/isFunction"));
var _numberFormatter = require("@active/core/number/numberFormatter");
var _utils = require("../Form/utils");
var _FormControl = require("../FormControl");
var _InputClearButton = _interopRequireDefault(require("../InputClearButton"));
var _excluded = ["type", "size", "lite", "disabled", "className", "htmlForm", "hasWarning", "hasError", "withClearButton", "withTextCount", "maxLength", "onChange", "preAddon", "postAddon", "style", "textAlign", "value", "formatTextCount", "textCountFormatterLocale"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var DEFAULT_SIZE = 'md';
var Input = function Input(_ref, ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    size = _ref.size,
    lite = _ref.lite,
    disabled = _ref.disabled,
    className = _ref.className,
    htmlForm = _ref.htmlForm,
    hasWarning = _ref.hasWarning,
    hasError = _ref.hasError,
    withClearButton = _ref.withClearButton,
    withTextCount = _ref.withTextCount,
    maxLength = _ref.maxLength,
    onChange = _ref.onChange,
    preAddon = _ref.preAddon,
    postAddon = _ref.postAddon,
    style = _ref.style,
    textAlign = _ref.textAlign,
    value = _ref.value,
    _ref$formatTextCount = _ref.formatTextCount,
    formatTextCount = _ref$formatTextCount === void 0 ? true : _ref$formatTextCount,
    _ref$textCountFormatt = _ref.textCountFormatterLocale,
    textCountFormatterLocale = _ref$textCountFormatt === void 0 ? 'en_US' : _ref$textCountFormatt,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var textCount = (0, _FormControl.useTextCount)();
  var active = (0, _FormControl.useActiveState)();
  var parsedValue = value === null ? '' : value;
  var innerRef = (0, _react.useRef)(null);
  var inputRef = ref && !(0, _isFunction["default"])(ref) ? ref : innerRef;
  var innerRefFn = function innerRefFn(el) {
    innerRef.current = el;
    (0, _isFunction["default"])(ref) && ref(el);
  };
  var handleClear = (0, _react.useCallback)(function () {
    var _inputRef$current, _inputRef$current$foc;
    onChange === null || onChange === void 0 || onChange({
      target: {
        value: ''
      }
    });
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || (_inputRef$current$foc = _inputRef$current.focus) === null || _inputRef$current$foc === void 0 || _inputRef$current$foc.call(_inputRef$current, {
      preventScroll: true
    });
  }, [onChange, inputRef]);
  var getTextCount = (0, _react.useCallback)(function () {
    if ((0, _isNil["default"])(maxLength)) {
      return !formatTextCount ? textCount : (0, _numberFormatter.intlNumberFormat)(textCount, textCountFormatterLocale);
    }
    if (!formatTextCount) {
      return "".concat(textCount, " / ").concat(maxLength);
    }
    return "".concat((0, _numberFormatter.intlNumberFormat)(textCount, textCountFormatterLocale), " / ").concat((0, _numberFormatter.intlNumberFormat)(maxLength, textCountFormatterLocale));
  }, [textCountFormatterLocale, maxLength, formatTextCount, textCount]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('input-group', (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, "input-group-".concat(size), size && size !== DEFAULT_SIZE), 'input-group-lite', lite), 'input-group-count', withTextCount), "active", active), "disabled", disabled), 'has-warning', hasWarning), 'has-error', hasError), className),
    style: style,
    "data-testid": "input-root"
  }, preAddon, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
    ref: (0, _isFunction["default"])(ref) ? innerRefFn : inputRef,
    type: type,
    className: (0, _classnames["default"])('form-control', (0, _defineProperty2["default"])({}, "text-".concat(textAlign), !!textAlign)),
    disabled: disabled,
    form: htmlForm,
    maxLength: maxLength,
    onChange: onChange,
    value: parsedValue,
    "data-testid": "input"
  }, (0, _utils.omitFormProps)(rest))), withClearButton && !!value && !disabled ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex align-items-center mg-r-4"
  }, /*#__PURE__*/_react["default"].createElement(_InputClearButton["default"], {
    "data-testid": "input-clear-btn",
    onClear: handleClear
  })) : null, withTextCount ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "input-group-addon",
    "data-testid": "input-text-count"
  }, getTextCount()) : null, postAddon);
};
var Composed = (0, _compose["default"])(_react.memo, _react["default"].forwardRef)(Input);
var InputFormControl = (0, _FormControl.withFormControl)(Composed);
var _default = exports["default"] = InputFormControl;